<script>
  import { formatEther } from "viem";
  import { getPublicClient, writeContract } from "@wagmi/core";

  import { chainExplorer, walletAddress } from "../stores.js";
  import { getABI, getContractValue, getContractJSONvalue } from "../utils.js";

  export let chain;
  export let address;

  let loadingData = true;
  let data;
  let max = 0;

  let building = false;
  let txHash;
  let feedback;

  $: $walletAddress, init();

  const init = async () => {
    if ($walletAddress) {
      let componentsAmount = await getContractValue(chain, address, 'componentsAmount');
      componentsAmount = Number(componentsAmount);
      const components = [];
      for (let idx = 0; idx < componentsAmount; idx++) {
        const component = await getContractValue(chain, address, 'components', [ idx ]);
        data = { contractAddress: component[0], tokenId: component[1], amount: component[2] }
        let [ balance, symbol ] = await Promise.all([
          getContractValue(chain, data.contractAddress, 'balanceOf', [ $walletAddress, idx ]),
          getContractJSONvalue(chain, data.contractAddress, data.tokenId, 'symbol')
        ]);
        balance = symbol ? BigInt(formatEther(balance)) : balance;
        if (balance > max) max = balance;
        components.push({ ...data, balance });
      }
      loadingData = false;

      console.log(components)
    }
  }

  const build = async () => {
    building = true;
    try {
      const { hash } = await writeContract({
        chainId: chain, address: address, abi: await getABI(address, chain), functionName: 'build'
      });
      txHash = hash;
    } catch (err) {
      if (err.shortMessage === 'User rejected the request.') {
        dispatch('user-cancel');
        new CustomEvent('user-cancel');
        allowing = undefined;
      } else {
        console.log(err)
        dispatch('error', err);
        new CustomEvent('error', { detail: err });
      }
      building = false;
      return;
    }

    for (const component of data) {
      data.balance -= data.amount;
    }
    max -= 1;

    dispatch('hashed', txHash);
    new CustomEvent('hashed', { detail: txHash });
    const receipt = await getPublicClient().waitForTransactionReceipt({ hash: txHash });
    dispatch('built', receipt)
    new CustomEvent('built', { detail: receipt });
    feedback = 'Built!';
    setTimeout(() => { feedback = undefined; }, 5000);
    txHash = undefined;
    building = false;
  }
</script>

{#if loadingData}
  Loading...
{:else if feedback}
  <span class={ $$props.class } class:lt-build={ true } class:feedback={ true }>{ feedback }</span>
{:else if txHash}
  <a href="{ $chainExplorer.url }/tx/{ txHash }" target="_blank">View tx</a>
{:else if max}
  <button class={ $$props.class } class:lt-build={ true } on:click={ build }>
    {#if building}
      <span class="loading loading-spinner"></span>
    {/if}
    Build
  </button>
{/if}